// Fonction pour initialiser les animations au défilement
export function initScrollAnimations() {
    // Fonction pour vérifier si un élément est visible dans la fenêtre
    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect()
        return rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8 && rect.bottom >= 0
    }

    // Fonction pour ajouter la classe active aux éléments visibles
    const handleScroll = () => {
        const elements = document.querySelectorAll(".wow, .img-block, .txt-block, .fbox-4, .review-4")

        elements.forEach((element, index) => {
            if (isElementInViewport(element)) {
                // Ajouter un délai basé sur l'index pour créer un effet en cascade
                element.style.setProperty("--animation-order", index % 5)
                element.classList.add("active")
            }
        })

        // Animation des compteurs
        const counters = document.querySelectorAll(".counter")
        counters.forEach((counter) => {
            if (isElementInViewport(counter) && !counter.classList.contains("counted")) {
                counter.classList.add("counted")
                const target = Number.parseInt(counter.getAttribute("data-count"))
                const suffix = counter.getAttribute("data-suffix") || ""
                let count = 0
                const duration = 2000 // ms
                const increment = Math.ceil(target / (duration / 30))
                const formatValue = (value) => {
                    const formatted = value.toLocaleString()
                    return suffix ? `${formatted}${suffix}` : formatted
                }

                const updateCount = () => {
                    count += increment
                    if (count >= target) {
                        counter.textContent = formatValue(target)
                        return
                    }
                    counter.textContent = formatValue(count)
                    setTimeout(updateCount, 30)
                }

                updateCount()
            }
        })
    }

    // Ajouter l'écouteur d'événement pour le défilement
    window.addEventListener("scroll", handleScroll)

    // Déclencher une fois au chargement
    setTimeout(handleScroll, 500)

    return () => {
        window.removeEventListener("scroll", handleScroll)
    }
}
